import { useCallback, useEffect, useState } from "react";
import { Service } from "../core/_models";
import { APIError, useAxios } from "../core/_axios";
import { getServices } from "../core/_requests_v2";

function useServices() {
    const axios = useAxios();

    const [loadingServices, setLoadingServices] = useState(true);
    const [services, setServices] = useState<Service[]>([]);
    const [errorLoadingServices, setErrorLoadingServices] = useState<string | null>(null);

    const loadAllServices = useCallback(async () => {
        setLoadingServices(true);
        setErrorLoadingServices(null);
        try {
            const {
                services
            } = await getServices(axios);
            setServices(services);
        } catch (exception) {
            console.error(exception)
            const errorMessage = exception instanceof APIError ? exception.message : 'An unknown error has occurred. Please try again.'
            setErrorLoadingServices(errorMessage)
        } finally {
            setLoadingServices(false)
        }
    }, [axios]);

    useEffect(() => {
        loadAllServices();
    }, [loadAllServices]);

    return {
        services,
        loadingServices,
        errorLoadingServices,
        loadAllServices,
    };

}

export default useServices;